/**
 * Adding class to page body if header is static
 */
if ($('.header').hasClass('header--static')) {
	$('body').addClass('has-static-header');
}